import * as React from "react";
const AiFillIcon = ({
  size = 12,
  title = "AiFillIcon",
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { width: size, height: size, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: "pds-icon", title, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10.784 6.35 8.761 7.361a3.133 3.133 0 0 0-1.401 1.401l-1.01 2.021a.392.392 0 0 1-.701 0l-1.01-2.02A3.133 3.133 0 0 0 3.237 7.36l-2.021-1.01a.392.392 0 0 1 0-.701l2.02-1.01A3.134 3.134 0 0 0 4.64 3.237l1.01-2.021a.392.392 0 0 1 .701 0l1.011 2.02A3.134 3.134 0 0 0 8.762 4.64l2.021 1.01a.392.392 0 0 1 0 .701Z", fill: "currentColor" }));
export default AiFillIcon;
